import ItemForm from "../components/itemForm";


const AddItem = () => {
  return <ItemForm isEdit={false} />;
};

export default AddItem;